.specialsRowDeals {
  padding: 16px var(--page-margin);
}

.filtersSelectorContainer {
  padding-left: var(--page-margin-desktop);
  padding-right: var(--page-margin-desktop);
}

.dealsButtons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .dealsButtons {
    display: none;
  }

  .specialsRowDeals {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
